var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTextVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2_00000154387827701670660130000006103416035093890949_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 191.9 346.9",
    style: {
      enableBackground: "new 0 0 191.9 346.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9B672;}\n\t.st1{fill:#EC6730;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.1,235.2l-8.9,27L38,295H21.9l-6.3-25.6V295H0v-59.8h15.6v23.2l6.9-23.2H37.1L37.1,235.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.9,235.2v40c0,4.5-0.2,7.7-0.4,9.5s-1.2,3.7-2.6,5.6s-3.4,3.4-5.7,4.4c-2.4,1-5.2,1.5-8.4,1.5 c-3.6,0-6.7-0.6-9.5-1.8s-4.8-2.7-6.1-4.6s-2.2-3.9-2.4-6s-0.4-6.5-0.4-13.3v-35.4h15.5V280c0,2.6,0.1,4.3,0.4,5 c0.3,0.7,0.9,1.1,1.7,1.1c1,0,1.6-0.4,1.9-1.2s0.4-2.7,0.4-5.7v-44.1L75.9,235.2L75.9,235.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.9,235.2h11c7.3,0,12.3,0.3,14.9,0.9s4.7,2,6.3,4.3c1.6,2.3,2.5,6,2.5,11.1c0,4.7-0.6,7.8-1.7,9.4 s-3.4,2.6-6.8,2.9c3.1,0.8,5.2,1.8,6.2,3.1s1.7,2.5,2,3.5s0.4,4,0.4,8.8V295h-14.4v-19.9c0-3.2-0.2-5.2-0.8-6s-1.8-1.1-4-1.1v27 H81.9V235.2L81.9,235.2z M97.5,245.4v13.3c1.8,0,3-0.2,3.7-0.7s1.1-2,1.1-4.7V250c0-1.9-0.3-3.1-1-3.7 C100.5,245.7,99.3,245.4,97.5,245.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.6,235.2l8.9,59.8h-15.9l-0.8-10.8h-5.6l-0.9,10.8h-16.1l7.9-59.8H149.6L149.6,235.2z M141.3,273.6 c-0.8-6.8-1.6-15.1-2.4-25.1c-1.6,11.4-2.6,19.8-3,25.1H141.3L141.3,273.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.8,346.2c0-19.7-9.5-35.6-21.2-35.6v35.6H21.8L21.8,346.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.8,346.2c0-19.7,9.5-35.6,21.2-35.6v35.6H21.8L21.8,346.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63,310.6l5.3,35.6h-9.5l-0.5-6.4H55l-0.6,6.4h-9.6l4.7-35.6H63L63,310.6z M58.1,333.5c-0.5-4-0.9-9-1.4-15 c-0.9,6.8-1.5,11.8-1.8,15H58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86,310.6v7.1h-5.5v28.5h-9.3v-28.5h-5.5v-7.1H86L86,310.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.2,310.6v23.8c0,2.7-0.1,4.6-0.3,5.7s-0.7,2.2-1.6,3.4c-0.9,1.1-2,2-3.4,2.6s-3.1,0.9-5,0.9 c-2.1,0-4-0.4-5.6-1.1s-2.8-1.6-3.7-2.8c-0.8-1.1-1.3-2.3-1.4-3.6s-0.2-3.9-0.2-7.9v-21.1h9.3v26.7c0,1.5,0.1,2.5,0.2,3 c0.2,0.4,0.5,0.6,1,0.6c0.6,0,1-0.2,1.1-0.7s0.2-1.6,0.2-3.4v-26.2L109.2,310.6L109.2,310.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.7,310.6h6.6c4.4,0,7.3,0.2,8.9,0.5c1.6,0.3,2.8,1.2,3.8,2.6s1.5,3.6,1.5,6.6c0,2.8-0.3,4.6-1,5.6 s-2,1.5-4.1,1.7c1.8,0.5,3.1,1.1,3.7,1.8s1,1.5,1.2,2.1c0.1,0.6,0.2,2.4,0.2,5.3v9.4h-8.6v-11.8c0-1.9-0.2-3.1-0.4-3.5 c-0.3-0.5-1.1-0.7-2.4-0.7v16h-9.2v-35.6H112.7z M122,316.7v7.9c1,0,1.8-0.1,2.2-0.4c0.4-0.3,0.6-1.2,0.6-2.8v-2 c0-1.1-0.2-1.9-0.6-2.2S123.1,316.7,122,316.7L122,316.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153,310.6l5.3,35.6h-9.5l-0.5-6.4H145l-0.6,6.4h-9.6l4.7-35.6H153L153,310.6z M148.1,333.5 c-0.5-4-0.9-9-1.4-15c-0.9,6.8-1.5,11.8-1.8,15H148.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.8,140.8c16.1,0,29.1-13,29.1-29.1h-29.1V140.8L162.8,140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.9,169.9c0-16.1-13-29.1-29.1-29.1v29.1H191.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.6,219.4h157.2V62.2C71,62.2,0.6,132.6,0.6,219.4z M113.3,111.8V82.7c16.1,0,29.1,13,29.1,29.1 C142.4,111.8,113.3,111.8,113.3,111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.9,58.2c0-16.1-13-29.1-29.1-29.1v29.1H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158,58.2C158,26,132,0,99.9,0v58.1H158V58.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTextVertical);
export default __webpack_public_path__ + "static/media/logo_text_vertical.0c7362f62e005e068f721b977d26e703.svg";
export { ForwardRef as ReactComponent };